import Alpine from 'alpinejs';

export default Alpine.data('navDropdown', () => ({
    init() {

        this.$watch('isOpen', () => {

            let y = Math.round(this.$el.getBoundingClientRect().y);

            if (this.isOpen == true) {
                this.$el.style.setProperty('--parent-y', `${y}px`);
            }
        });
    },
    isOpen: false,
    trigger: {
        ['@click']() {
            this.isOpen = !this.isOpen;
        },
        [':aria-expanded']() {
            return this.isOpen.toString();
        },
        [':class']() {
            return { 
                'is-active': this.isOpen 
            }
        }
    },
    navDropdownParent: {
        ['@click.away']() {
            this.isOpen = false;
        }
    },
    childMenu: {
        [':aria-expanded']() {
            return this.isOpen.toString();
        },
        ['x-transition:enter']: 'transition desktop-nav:delay-100 duration-200',
        ['x-transition:enter-start']: 'opacity-0',
        ['x-transition:enter-end']: 'opacity-100',
        ['x-transition:leave']: 'transition duration-200',
        ['x-transition:leave-start']: 'opacity-100',
        ['x-transition:leave-end']: 'opacity-0',
        ['x-show']() {
            return this.isOpen;
        },
    },
}));